import clsx from "clsx";

interface IChip {
  label?: string;
  className?: string;
  color: string;
}

const Chip = ({ label, className, color }: IChip) => {
  const getColor = (type: string) => {
    switch (type) {
      case "white":
        return "bg-white";
      default:
        return "bg-white";
    }
  };

  return (
    <div
      className={clsx(
        "w-[26px] h-5 flex justify-center items-center border border-solid rounded-[6px] text-xs border-[#0A0F290A]",
        getColor(color),
        className,
      )}
    >
      {label}
    </div>
  );
};

export default Chip;
